@if (control.controlType === 'monthPicker') {
  <app-month-picker [parentForm]="parentForm" [questionNumber]="control.key" [label]="control.label"></app-month-picker>
}
@if (parentForm) {
  <form [formGroup]="parentForm">
    @if (control.controlType === 'input') {
      <div [id]="control.key">
        <prism-ui-form-field
          [keyId]="control.key"
          [isValid]="formControlUtilitiesService.isControlValid(parentForm, control.key)"
          >
          <span slot="label">{{control.label}}</span>
          @if (parentForm.get(control.key)?.errors?.['required'] &&
              (parentForm.get(control.key)?.touched ||
              parentForm.get(control.key)?.dirty) || parentForm.get(control.key)?.errors?.['min']) {
            <span slot="error">{{ requiredElement?.error }}</span>
          }
          @if (parentForm.get(control.key)?.errors?.['pattern'] &&
            (parentForm.get(control.key)?.touched )) {
            <span slot="error">Invalid value</span>
          }
          <prism-ui-input-text
            autocomplete="new-password"
            slot="input"
            is-required="true"
            [maxLength]="maxLength"
            ngDefaultControl
            [name]="fieldName"
            [formControlName]="control.key"
            [formGroup]="parentForm"
            [keyId]="control.key"
            placeholder="{{control.label}}"
            [defaultValue]="parentForm.get(control.key)?.value"
            [isValid]="formControlUtilitiesService.isControlValid(parentForm, control.key)"
            (focusout)="inputLeaveEvent($event, control.key)"
          ></prism-ui-input-text>
        </prism-ui-form-field>
      </div>
    }
  </form>
}
@if (control.controlType === 'buttonToggle') {
  <app-button-toggle [label]="control.label" [key]="control.key" [parentForm]="parentForm" [toggleOptions]="control.toggleOptions"></app-button-toggle>
}